import { Engine } from '@/core/engine';
import { showLoading } from '@/core/loading';
import { registerModules } from '@/modules';

async function main(): Promise<void> {
  const mount = document.getElementById('app');
  if (!mount) throw new Error('missing #app');

  const loading = showLoading(mount);
  const engine = new Engine(mount);

  // Start conservative on unknown hardware; the player can raise it in settings.
  engine.settings.applyTier(engine.settings.autoDetectTier());

  try {
    await registerModules(engine);
    await engine.boot((frac, label) => loading.progress(frac, label));
    loading.done();
  } catch (err) {
    console.error(err);
    loading.fail(err instanceof Error ? err.message : String(err));
    return;
  }

  // Expose for the screenshot harness and in-browser debugging.
  (window as unknown as { game: Engine }).game = engine;
  window.dispatchEvent(new CustomEvent('game:ready'));
}

void main();
